import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { UnifiedLoginService, NpsCommonService } from '@monorepo/services';

@Component({
  selector: 'app-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss'],
})
export class AppShellComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  constructor(private unifiedLoginService: UnifiedLoginService, private npsCommonService: NpsCommonService) {}

  ngOnInit(): void {
    this.handleNpsFlow();
  }

  handleNpsFlow() {
    this.unifiedLoginService.loginStatus$
      .pipe(
        filter((loginStatus) => loginStatus === 'FRESH_LOGIN'),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        const userInfo = this.unifiedLoginService.getUserInfo();
        this.npsCommonService.initForm({
          product: 'Tracki8',
          platform: 'OI App',
          subject_key: userInfo.factoryId,
          user_name: userInfo.username,
        });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
